import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CampaignDetailsDto } from '@dto/campaign/campaign-by-product-id.dto';
import { Store } from '@ngrx/store';
import { getCampaignsByProductIdApiCall } from '@store/campaign/campaign.selector';
import { State } from '@store/state';
import { NullableType } from '@type/nullable.type';
import { filter, map } from 'rxjs';
import { CAMPAIGN_LIST_PAGE } from 'src/app/app.routes';

export const campaignsGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const store = inject(Store<State>);

    const campaignId: string = route.params?.['campaignId'];

    return store.select(getCampaignsByProductIdApiCall).pipe(
        filter((apiCall) => !!apiCall.hasBeenCalled && !apiCall.isLoading),
        map((apiCall) => {
            const campaign : NullableType<CampaignDetailsDto> = Object.values(apiCall.data || {}).flat().find(c => c.id === campaignId);
            if (!campaign || (campaign.status !== "DRAFT" && campaign.status !== "SCHEDULED")) {
                router.navigate([`/${CAMPAIGN_LIST_PAGE}`]);
                return false;
            }
            return true;    
        })
    );
};